export default __webpack_public_path__ + "static/media/zte_wireless.9d9d0c04.png";